import {
  createConsent,
  type CookieConsent,
  type CookieConsentDraft,
} from './cookie-consent.types';

const STORAGE_KEY = 'cookie-consent';

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object';
}

function parseConsent(raw: string): CookieConsent | null {
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!isRecord(parsed)) return null;
    if (parsed.necessary !== true) return null;
    if (typeof parsed.analytics !== 'boolean') return null;
    if (typeof parsed.marketing !== 'boolean') return null;
    if (typeof parsed.timestamp !== 'string' || !parsed.timestamp) return null;

    return {
      necessary: true,
      analytics: parsed.analytics,
      marketing: parsed.marketing,
      timestamp: parsed.timestamp,
    };
  } catch {
    return null;
  }
}

export const cookieConsentStorage = {
  get(): CookieConsent | null {
    if (typeof window === 'undefined') return null;
    const value = localStorage.getItem(STORAGE_KEY);
    if (!value) return null;
    return parseConsent(value);
  },

  save(consent: CookieConsent): void {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  },

  saveDraft(draft: CookieConsentDraft): CookieConsent {
    const consent = createConsent(draft);
    this.save(consent);
    return consent;
  },

  clear(): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(STORAGE_KEY);
  },

  allowsAnalytics(): boolean {
    return this.get()?.analytics === true;
  },

  allowsMarketing(): boolean {
    return this.get()?.marketing === true;
  },
};
